var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1577_5648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48608 2 2 6.48608 2 12C2 17.514 6.48608 22 12 22C17.514 22 22 17.514 22 12C22 6.48608 17.5139 2 12 2ZM12.6505 17.9333C12.1754 18.0125 11.2301 18.2103 10.75 18.25C10.3437 18.2837 9.96021 18.0511 9.72646 17.7172C9.4921 17.3833 9.43594 16.9561 9.57508 16.5728L11.4653 11.375H9.49999C9.49832 10.292 10.3107 9.49561 11.3497 9.18998C11.8456 9.04409 12.7694 8.84445 13.25 8.87505C13.5379 8.89336 14.0398 9.074 14.2735 9.4079C14.5079 9.74176 14.5641 10.169 14.4249 10.5523L12.5347 15.7501H14.4994C14.4998 16.8319 13.7177 17.7554 12.6505 17.9333ZM13.25 8.25002C12.5596 8.25002 12 7.69031 12 7.00001C12 6.30963 12.5596 5.75 13.25 5.75C13.9404 5.75 14.5 6.30963 14.5 7.00001C14.5 7.69035 13.9404 8.25002 13.25 8.25002Z",
    fill: "#2693A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1577_5648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.2cc4dfbe.svg";
export { ForwardRef as ReactComponent };